import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";
export const WorkflowsIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Workflows Icon</title>;
    t1 = <path fill="currentColor" d="M624-216v-36H516q-29.7 0-50.85-21.15Q444-294.3 444-324v-312H336v36q0 29.7-21.15 50.85Q293.7-528 264-528h-96q-29.7 0-50.85-21.18Q96-570.35 96-600.09v-144.17Q96-774 117.15-795q21.15-21 50.85-21h96q29.7 0 50.85 21.15Q336-773.7 336-744v36h288v-36.16Q624-774 645.15-795q21.15-21 50.85-21h96q29.7 0 50.85 21.18Q864-773.65 864-743.91v144.17Q864-570 842.85-549 821.7-528 792-528h-96q-29.7 0-50.85-21.15Q624-570.3 624-600v-36H516v312h108v-36.16Q624-390 645.15-411q21.15-21 50.85-21h96q29.7 0 50.85 21.18Q864-389.65 864-359.91v144.17Q864-186 842.85-165 821.7-144 792-144h-96q-29.7 0-50.85-21.15Q624-186.3 624-216ZM168-744v144-144Zm528 384v144-144Zm0-384v144-144Zm0 144h96v-144h-96v144Zm0 384h96v-144h-96v144ZM168-600h96v-144h-96v144Z" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="1em" height="1em" viewBox="0 -960 960 960" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};